/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiOnboardingStepFromJSON, ApiOnboardingStepToJSON, } from './ApiOnboardingStep';
import { ApiOnboardingTypeFromJSON, ApiOnboardingTypeToJSON, } from './ApiOnboardingType';
export function ApiSimpleOnboardingFromJSON(json) {
    return ApiSimpleOnboardingFromJSONTyped(json, false);
}
export function ApiSimpleOnboardingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'approvedDate': !exists(json, 'approvedDate') ? undefined : (new Date(json['approvedDate'])),
        'basicInfoApproved': !exists(json, 'basicInfoApproved') ? undefined : (new Date(json['basicInfoApproved'])),
        'businessInfoApproved': !exists(json, 'businessInfoApproved') ? undefined : (new Date(json['businessInfoApproved'])),
        'connectionsApproved': !exists(json, 'connectionsApproved') ? undefined : (new Date(json['connectionsApproved'])),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'learningShown': !exists(json, 'learningShown') ? undefined : json['learningShown'],
        'locationsApproved': !exists(json, 'locationsApproved') ? undefined : (new Date(json['locationsApproved'])),
        'onboardingType': !exists(json, 'onboardingType') ? undefined : ApiOnboardingTypeFromJSON(json['onboardingType']),
        'pixelApproved': !exists(json, 'pixelApproved') ? undefined : (new Date(json['pixelApproved'])),
        'platformApproved': !exists(json, 'platformApproved') ? undefined : (new Date(json['platformApproved'])),
        'predictionsDone': !exists(json, 'predictionsDone') ? undefined : (new Date(json['predictionsDone'])),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'publishedDate': !exists(json, 'publishedDate') ? undefined : (new Date(json['publishedDate'])),
        'uiStep': !exists(json, 'uiStep') ? undefined : ApiOnboardingStepFromJSON(json['uiStep']),
        'uiStepAdmin': !exists(json, 'uiStepAdmin') ? undefined : ApiOnboardingStepFromJSON(json['uiStepAdmin']),
    };
}
export function ApiSimpleOnboardingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'approvedDate': value.approvedDate === undefined ? undefined : (value.approvedDate.toISOString()),
        'basicInfoApproved': value.basicInfoApproved === undefined ? undefined : (value.basicInfoApproved.toISOString()),
        'businessInfoApproved': value.businessInfoApproved === undefined ? undefined : (value.businessInfoApproved.toISOString()),
        'connectionsApproved': value.connectionsApproved === undefined ? undefined : (value.connectionsApproved.toISOString()),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'id': value.id,
        'learningShown': value.learningShown,
        'locationsApproved': value.locationsApproved === undefined ? undefined : (value.locationsApproved.toISOString()),
        'onboardingType': ApiOnboardingTypeToJSON(value.onboardingType),
        'pixelApproved': value.pixelApproved === undefined ? undefined : (value.pixelApproved.toISOString()),
        'platformApproved': value.platformApproved === undefined ? undefined : (value.platformApproved.toISOString()),
        'predictionsDone': value.predictionsDone === undefined ? undefined : (value.predictionsDone.toISOString()),
        'projectId': value.projectId,
        'publishedDate': value.publishedDate === undefined ? undefined : (value.publishedDate.toISOString()),
        'uiStep': ApiOnboardingStepToJSON(value.uiStep),
        'uiStepAdmin': ApiOnboardingStepToJSON(value.uiStepAdmin),
    };
}
